import { cn, platformProps } from "../../lib";
import { Box } from "../../primitives";
import { AccountMenuPanelFooter } from "./account-menu-panel-footer";
import { AccountMenuPanelHeader } from "./account-menu-panel-header";
import { AccountMenuPanelSection } from "./account-menu-panel-section";
import type { AccountMenuPanelProps } from "./types";

/**
 * AccountMenuPanel — vertical panel rendered inside AccountMenu.
 *
 * Compound API: consumers compose `Header / Section / Footer`
 * freely. The DS does not own the row content; consumers drop in
 * <ListItem /> (or anything) inside Sections.
 *
 * Footer is pinned to the bottom via `mt-auto` so it always sits
 * at the bottom regardless of section count or content height.
 */
const AccountMenuPanelRoot = ({ children, className, testID }: AccountMenuPanelProps) => (
  <Box
    {...platformProps({ testID, slot: "account-menu-panel" })}
    className={cn("bg-luce-neutral-background-default flex h-full flex-col", className)}
  >
    {children}
  </Box>
);

AccountMenuPanelRoot.displayName = "AccountMenuPanel";

export const AccountMenuPanel = Object.assign(AccountMenuPanelRoot, {
  Header: AccountMenuPanelHeader,
  Section: AccountMenuPanelSection,
  Footer: AccountMenuPanelFooter,
});
